define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/Container",
	"csi/middleware/attributes/attributeKeysService",
], function(declare, _, Container, {flattenAttributeKeys}) {

	return declare(Container, {
		restrictQuery: true,
		type: "stringlist",

		/**
		 * @override
		 * Return attribute keys in view
		 */
		_getValue(ctx, h) {
			const cv = ctx.getNode();
			const key = ctx.view._getContainerKey(cv);
			const view = ctx.view._getViewDefinition(key, cv);
			if (!view) {
				return null;
			}

			const nestedViews = ctx.view._getNestedViewKeys(view);
			if (nestedViews) {
				return nestedViews;
			}

			return flattenAttributeKeys(view.attributeKeys, true);
		}
	});
});